import { CrawledPostManangementData, PaginationData } from '@/Interfaces/I_postManagement';
import { createSlice } from '@reduxjs/toolkit';

const crawledPostManagementSlice = createSlice({
  name: 'crawledPostManangement',
  initialState: {
    value: {
      crawledPost: {
        data: [] as CrawledPostManangementData[],
        pagination: {} as PaginationData,
      }
    },
    loading: false,
    error: '',
  },
  reducers: {
    getCrawledPost: (state, action) => {
      const assignState = state;
      assignState.loading = true;
    },
    setCrawledPost: (state, action) => {
      const assignState = state;
      assignState.value = { ...assignState.value, crawledPost: action.payload.data };
      assignState.loading = false;
    },
    patchCrawledPost: (state, action) => {
      const assignState = state;
      assignState.loading = true;
    },
    patchCrawledPostSucess: (state, action) => {
      const assignState = state;
      const mockData = assignState.value.crawledPost.data;
      const target = mockData.findIndex((element) => element.uuid === action.payload.postUuid);
      mockData[target].disabled = action.payload.disabled;
      assignState.value.crawledPost.data = mockData;
      assignState.loading = false;
    },
    patchCrawledPostFailed: (state, action) => {
      const assignState = state;
      assignState.error = action.payload;
      assignState.loading = false;
    }
  }
})

export const {
  getCrawledPost,
  setCrawledPost,
  patchCrawledPost,
  patchCrawledPostSucess,
  patchCrawledPostFailed,
} = crawledPostManagementSlice.actions;

export default crawledPostManagementSlice.reducer;